import { z } from "zod"
import { TranslationKey } from "../i18n/translation-key"

export const DeliveryProductSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  ean: z.string().nullable(),
  storeId: z.string().uuid(),
  createdAt: z.date(),
})

export type DeliveryProduct = z.infer<typeof DeliveryProductSchema>

export const SaveDeliveryProductSchema = z.object({
  title: z
    .string()
    .min(1, "common.validation.productNameRequired" satisfies TranslationKey),
  ean: z.string().optional(),
})

export type SaveDeliveryProduct = z.infer<typeof SaveDeliveryProductSchema>
